import { FC } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TrashIcon } from "@radix-ui/react-icons";
import IconBookmarkList from "@/assets/images/icon_bookmark_list.svg";
import { Button } from "../ui/button";
import { useBookmarkView } from "./BookmarkView.hooks";
import { AlertMessageDialog, ConfirmMessageDialog } from "../MessageDialog";
import { Link } from "react-router-dom";
import { DataSchema } from "common";

export const BookmarkView: FC = () => {
  const {
    t,
    bookmarks,
    open,
    setOpen,
    onClickTrash,
    deleteBookmark,
    deleteConfirmOpen,
    setDeleteConfirmOpen,
    apiErrorDialogOpen,
    setApiErrorDialogOpen,
    apiErrorMessage,
    callDeleteBookmark,
  } = useBookmarkView();

  const bookmarkTitle = (data?: DataSchema.Bookmark) => {
    return `P.${data?.pageNo ?? "0"}:${data?.documentTitle ?? ""}`;
  };

  return (
    <>
      <div className="flex flex-col">
        <Button className="h-10 w-10 p-0" variant="ghost" onClick={() => setOpen(!open)}>
          <img src={IconBookmarkList} className="h-4 w-4" />
        </Button>

        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger className="w-10" />

          <DropdownMenuContent className="w-[296px] max-w-[100vw] p-0 sm:w-[296px] sm:max-w-[296px]" align="end">
            <div className="max-h-[calc(100svh-150px)] overflow-y-auto overflow-x-hidden py-2 sm:max-h-[calc(100svh-150px)]">
              {bookmarks.length === 0 && (
                <div className="px-4 py-1">
                  <p className="text-base text-gray-500">{t("bookmark_empty")}</p>
                </div>
              )}
              {bookmarks.map((data, index) => {
                const params = new URLSearchParams();
                params.append("page", data.pageNo.toString());
                const linkTo = `/documents/${data.documentId}?${params.toString()}`;

                return (
                  <DropdownMenuItem
                    key={index}
                    className="mx-2 flex h-8 max-h-8 flex-row gap-x-2 pl-2 pr-0 data-[disabled]:opacity-100"
                  >
                    <Link className="flex-1" to={linkTo} target="_blank" onClick={(e) => e.stopPropagation()}>
                      <p className="max-h-8 max-w-[228px] flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-base">
                        {bookmarkTitle(data)}
                      </p>
                    </Link>

                    <div className="min-h-8 min-w-8">
                      <Button
                        variant="ghost"
                        className="h-8 w-8 p-0"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClickTrash(data);
                        }}
                      >
                        <TrashIcon className="h-4 w-4" />
                      </Button>
                    </div>
                  </DropdownMenuItem>
                );
              })}
            </div>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <ConfirmMessageDialog
        open={deleteConfirmOpen}
        setOpen={setDeleteConfirmOpen}
        title={t("delete_title", { title: bookmarkTitle(deleteBookmark) })}
        message={t("delete_message")}
        actionButtonLabel={t("delete")}
        actionButtonBg="bg-destructive"
        onClickAction={callDeleteBookmark}
        cancelButtonLabel={t("cancel")}
      />
      <AlertMessageDialog open={apiErrorDialogOpen} message={apiErrorMessage} setOpen={setApiErrorDialogOpen} />
    </>
  );
};
